import { Note, SampleName, SIGNATURE } from '@/types.ts';

export const NOTES: Record<string, Note> = {
  C: {
    name: 'C',
    major: { sample: 'C', offset: -150 },
    minor: { sample: 'Cm', offset: -150 },
    dominant: { sample: 'C7', offset: -150 },
  },
  CS: {
    name: 'C♯',
    major: { sample: 'CS', offset: -150 },
    minor: { sample: 'CSm', offset: -200 },
    dominant: { sample: 'CS7', offset: -180 },
  },
  D: {
    name: 'D',
    major: { sample: 'D', offset: -180 },
    minor: { sample: 'Dm', offset: -150 },
    dominant: { sample: 'D7', offset: -150 },
  },
  Eb: {
    name: 'E♭',
    major: { sample: 'Eb', offset: -150 },
    minor: { sample: 'Ebm', offset: -150 },
    dominant: { sample: 'Eb7', offset: -150 },
  },
  E: {
    name: 'E',
    major: { sample: 'E', offset: -175 },
    minor: { sample: 'Em', offset: -180 },
    dominant: { sample: 'E7', offset: -175 },
  },
  F: {
    name: 'F',
    major: { sample: 'F', offset: -150 },
    minor: { sample: 'Fm', offset: -120 },
    dominant: { sample: 'F7', offset: -150 },
  },
  FS: {
    name: 'F♯',
    major: { sample: 'FS', offset: -150 },
    minor: { sample: 'FSm', offset: -200 },
    dominant: { sample: 'FS7', offset: -150 },
  },
  G: {
    name: 'G',
    major: { sample: 'G', offset: -150 },
    minor: { sample: 'Gm', offset: -120 },
    dominant: { sample: 'G7', offset: -150 },
  },
  GS: {
    name: 'G♯',
    major: { sample: 'GS', offset: -120 },
    minor: { sample: 'GSm', offset: -200 },
    dominant: { sample: 'GS7', offset: -150 },
  },
  A: {
    name: 'A',
    major: { sample: 'A', offset: -150 },
    minor: { sample: 'Am', offset: -150 },
    dominant: { sample: 'A7', offset: -150 },
  },
  Bb: {
    name: 'B♭',
    major: { sample: 'Bb', offset: -120 },
    minor: { sample: 'Bbm', offset: -150 },
    dominant: { sample: 'Bb7', offset: -120 },
  },
  B: {
    name: 'B',
    major: { sample: 'B', offset: -150 },
    minor: { sample: 'Bm', offset: -150 },
    dominant: { sample: 'B7', offset: -120 },
  },
};

export const NOTE_OPTIONS = Object.entries(NOTES).map(([key, value]) => ({ key, value: value.name }));

export function getTimeByKey(key: string): SIGNATURE {
  switch (key) {
    case '3/4':
      return SIGNATURE['3/4'];
    case '5/4':
      return SIGNATURE['5/4'];
    case '6/8':
      return SIGNATURE['6/8'];
    case '7/8':
      return SIGNATURE['7/8'];
    case '12/8':
      return SIGNATURE['12/8'];
    default:
    case '4/4':
      return SIGNATURE['4/4'];
  }
}

export const SIGNATURE_OPTIONS = Object.entries(SIGNATURE).map(([key, value]) => ({ key, value }));

export const DEFAULT_BPM = 120;

export const METRONOME_PATTERNS: Record<SIGNATURE, SampleName[]> = {
  '3/4': ['hi', 'mi', 'mi'],
  '4/4': ['hi', 'mi', 'mi', 'mi'],
  '5/4': ['hi', 'lo', 'lo', 'mi', 'lo'],
  '6/8': ['hi', 'lo', 'lo', 'mi', 'lo', 'lo'],
  '7/8': ['hi', 'lo', 'mi', 'lo', 'mi', 'lo', 'lo'],
  '12/8': ['hi', 'lo', 'lo', 'mi', 'lo', 'lo', 'mi', 'lo', 'lo', 'mi', 'lo', 'lo'],
};
